import { styled } from '@mui/material';
import { Tabs as MuiTabs, Tab } from '@mui/material';
import Box from '../Box/Box';

export const Tabs = styled(MuiTabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`
}));

export const TabStyled = styled(Tab)<{ to?: string; component?: React.ElementType }>(({ theme }) => ({
  '&.Mui-selected': {
    color: theme.palette.text.primary
  },
  textTransform: 'none',
  fontWeight: theme.typography.body1.fontWeight,
  fontSize: theme.typography.body1.fontSize
}));

export const TabsRightContentSlot = styled(Box, { name: 'TabsRightContentSlot' })`
  margin-left: auto;
  display: flex;
  align-items: center;
`;
